module.exports = __webpack_public_path__ + "assets/img/Intro.037a0b12.svg";